module.exports = "<svg viewBox=\"0 0 13.8 13.8\"><path d=\"M13.8 7.8V0C6.2 0 0 6.2 0 13.8h7.8c0-3.3 2.7-6 6-6z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/circle-quarter.svg
// module id = 277
// module chunks = 1